(function ($) {
  const queryParamsElements = $("div[data-query-params]").get();

  for (const queryParamsElement of queryParamsElements) {
    if (!queryParamsElement) return;
    const listId = $(queryParamsElement).attr("data-grid-wrapper-id");
    if (!listId) return;

    const searchInput = $('input[data-posts-search="true"]');

    function debounce(callback, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          callback.apply(this, args);
        }, timeout);
      };
    }
    const processChange = debounce(searchPosts);

    $(searchInput).keyup((ev) => processChange(ev.target.value));
    $(searchInput).change((ev) => processChange(ev.target.value));

    function searchPosts(query = "") {
      const processing =
        $(queryParamsElement).attr("data-processing") === "true" ?? false;
      const prevQuery = $(queryParamsElement).attr("data-query-string");

      if (processing || query === prevQuery) return;

      /* ====== Scroll Theme columns back ========== */
      $(`#${listId} .theme-columns`).scrollLeft(0);

      $(queryParamsElement).attr("data-processing", true);
      $(searchInput).prop("disabled", true);

      const listElement = $(`#${listId} .posts-grid`).get(0);
      const noResultsElement = $(`#${listId} .no-results`);
      const paginationElement = $(`#${listId} .pagination`);
      const originalArgs = $(queryParamsElement)
        .children("[data-query-args]")
        ?.text();
      const ajaxUrl = siteConfig?.ajaxUrl ?? "";
      const ajaxNonce = siteConfig?.ajaxNonce ?? "";

      if (!searchInput || !ajaxUrl || !ajaxNonce || !originalArgs) return;

      const ajax = $(queryParamsElement).attr("data-ajax-query") === "true";
      const categoryId = $(queryParamsElement).attr("data-category-id") ?? "";
      const engagement = $(queryParamsElement).attr("data-engagement") ?? "";
      const gridId = $(queryParamsElement).attr("data-grid-id") ?? "";
      const gridClass = $(queryParamsElement).attr("data-grid-class") ?? "";
      const sectionId =
        $(queryParamsElement).attr("data-grid-wrapper-id") ?? "";
      const lazy = $(queryParamsElement).attr("data-lazy-query") === "true";
      const noResultsText =
        $(queryParamsElement).attr("data-no-results-text") ?? "";
      const prevNextLinks =
        $(queryParamsElement).attr("data-prev-next-links") === "true";
      const sortBy = $(queryParamsElement).attr("data-sort-by");
      const sortByCustomField =
        $(queryParamsElement).attr("data-sort-by-custom-field") === "true";
      const sortOrder = $(queryParamsElement).attr("data-sort-order");
      const templateArgs = $(queryParamsElement)
        .children("[data-template-args]")
        ?.text();
      const templateKey = $(queryParamsElement).attr("data-template-key") ?? "";
      const termId = $(queryParamsElement).attr("data-term-id") ?? "";

      $.ajax({
        url: ajaxUrl,
        type: "post",
        data: {
          action: "search_posts",
          ajax,
          ajax_nonce: ajaxNonce,
          args: JSON.parse(originalArgs || "{}"),
          category_id: categoryId,
          engagement,
          grid_id: gridId,
          grid_class: gridClass,
          lazy,
          no_results_text: noResultsText,
          prev_next_links: prevNextLinks,
          query,
          section_id: sectionId,
          sort_by: sortBy,
          sort_by_custom_field: sortByCustomField,
          sort_order: sortOrder,
          template_args: JSON.parse(templateArgs || "{}"),
          template_key: templateKey,
          term_id: termId,
        },
        success: (response) => {
          $(document).scrollTop(1250);

          if (!response || response.success === false) return;
          if (!!listElement) {
            $(listElement).parent().append(response);
            $(listElement).remove();
            if (!!paginationElement) $(paginationElement).remove();
          } else if (!!noResultsElement) {
            $(noResultsElement).parent().append(response);
            $(noResultsElement).remove();
          }
          $(queryParamsElement).attr("data-processing", false);
          $(searchInput).prop("disabled", false);
          $(searchInput).focus();
          $(queryParamsElement).attr("data-query-string", query);
        },
        error: (error) => {
          console.error(error);
          $(searchInput).prop("disabled", false);
          $(searchInput).focus();
          $(queryParamsElement).attr("data-query-string", query);
          $(queryParamsElement).attr("data-processing", false);
        },
      });
    }
  }
})(jQuery);
